import type { AiBrowsingEvent } from "@/lib/ai/storage/types";

export function formatAddressShortId(addressId: string) {
	if (!addressId) {
		return "";
	}

	if (addressId.length <= 8) {
		return addressId;
	}

	return `${addressId.slice(0, 5)}...${addressId.slice(-3)}`;
}

export function formatTokenDisplayLabel(
	entitySymbol?: string | null,
	entityId?: string | null,
) {
	const tokenId = entityId?.trim() ?? "";
	const ticker = entitySymbol?.trim() ?? "";

	if (ticker && tokenId) {
		return `${ticker}(#${tokenId})`;
	}

	if (tokenId) {
		return `Token(#${tokenId})`;
	}

	return ticker || "Token";
}

export function formatAddressDisplayLabel(
	entityDisplayName?: string | null,
	entityId?: string | null,
) {
	const addressId = entityId?.trim() ?? "";
	const name = entityDisplayName?.trim() ?? "";
	const shortId = formatAddressShortId(addressId);

	if (name && shortId) {
		return `${name}（${shortId}）`;
	}

	if (shortId) {
		return `地址（${shortId}）`;
	}

	return name || "地址";
}

export function getAiBrowsingDisplayLabel(event: Pick<
	AiBrowsingEvent,
	"entityType" | "entityId" | "entityDisplayName" | "entitySymbol" | "label"
>) {
	if (event.entityType === "token") {
		return formatTokenDisplayLabel(event.entitySymbol, event.entityId);
	}

	if (event.entityType === "address") {
		return formatAddressDisplayLabel(event.entityDisplayName, event.entityId);
	}

	return event.label;
}
